import withSlice from '@screens/SlicesContainer/withSlice';
import { ICtaButton } from './types';
import HyperLink from '@monofront/design-system/components/HyperLink';
import { mapCtaButton } from './mapCtaButton';

/**
 * @deprecated Component deprecated but kept for retro compatibility with old prismic schema - See OneCta or TwoCta
 */

const DeprecatedCtaButton: React.FC<ICtaButton> = ({ link, text }) => {
  return (
    <>
      <div className="cta-button">
        <HyperLink variant="button-primary" size="large" to={link}>
          {text}
        </HyperLink>
      </div>
      <style jsx>{`
        .cta-button {
          display: flex;
          justify-content: center;
          margin-top: var(--negative-space-5);
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default withSlice(DeprecatedCtaButton, mapCtaButton);
